module.exports = __webpack_public_path__ + "img/imgfftBR50.825dc2b5.png";